const env = require("services/env");
const router = require("services/router");
const store = require("stores/TeachersStore");
const {queryObject} = require("helpers/object");
const {encodeState} = require("helpers/url");

function initialize() {
	// Do not boot if server side
	if (env.server()) {
		return;
	}

	// Push new state when the store constraints change
	store.constraintChange.pipe(state => {
		const currentState = encodeState(history.state);
		const newState = encodeState(state);

		// Only update if the new state is different (no need to push new state to history
		// if they are the same)
		if (currentState !== newState) {
			const area = queryObject(state, "area.name");

			history.pushState(
				state,
				area ? `Find underviser i ${area}` : `Find underviser`,
				router.route("find-teachers", {state: newState})
			);
		}

		return state;
	});

	// Update constraints on pop state
	window.addEventListener("popstate", ({state}) => {
		if (state && typeof state === "object") {
			store.constrain(state, true);
		}
	});
}

module.exports = initialize;


// WEBPACK FOOTER //
// ./resources/js/routes/find-teachers.js